export default __webpack_public_path__ + "static/media/army_23.b4054951.jpg";